import React from 'react'
import { l } from '@manychat/manyui'

import { TouchedContactLimits } from 'common/billing/constants/TouchedContactLimits'

export const ActiveContactsText = ({ activeContacts }: { activeContacts: number }) => {
  if (!activeContacts) {
    return (
      <span className="text-secondary">
        {l.translate('No Active Contacts engaged this month. All good for the new Free plan.')}
      </span>
    )
  }
  if (activeContacts <= TouchedContactLimits.free) {
    return (
      <span className="text-secondary">
        {l.translate(
          'You have {activeContacts} Active Contacts this month. All good for the new Free plan.',
          { activeContacts },
        )}
      </span>
    )
  }
  return (
    <span className="text-warning">
      {l.translate(
        '<b>Your automations are paused.</b> You have {activeContacts} Active Contacts this month, over your new Free plan limit of 25.',
        { activeContacts },
      )}
    </span>
  )
}
